
export class DeliveryMarkAsDeliveredDTO{
    public Comment?: string = undefined;
    public FileId?: string = undefined;
}